import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

export const getIntegrations = async (params) => {
  const { data } = await clasolSuiteApi.get('/integrations', {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getIntegration = async (id) => {
  const { data } = await clasolSuiteApi.get(`/integrations/${encodeURIComponent(id)}`, withSuiteAdminCode())
  return data
}

export const getIntegrationExecutions = async (id, params) => {
  const { data } = await clasolSuiteApi.get(`/integrations/${encodeURIComponent(id)}/executions`, {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getIntegrationExecutionDetails = async (id, executionId) => {
  const { data } = await clasolSuiteApi.get(
    `/integrations/${encodeURIComponent(id)}/executions/${encodeURIComponent(executionId)}`,
    withSuiteAdminCode(),
  )
  return data
}

export const getIntegrationOpenErrors = async (id, params) => {
  const { data } = await clasolSuiteApi.get(`/integrations/${encodeURIComponent(id)}/errors`, {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const resolveIntegrationError = async (id, errorId) => {
  const { data } = await clasolSuiteApi.patch(
    `/integrations/${encodeURIComponent(id)}/errors/${encodeURIComponent(errorId)}/resolve`,
    null,
    withSuiteAdminCode(),
  )
  return data
}

export const createIntegration = async (integration) => {
  const { data } = await clasolSuiteApi.post('/integrations', integration, withSuiteAdminCode())
  return data
}

export const updateIntegration = async (id, integration) => {
  const { data } = await clasolSuiteApi.patch(`/integrations/${encodeURIComponent(id)}`, integration, withSuiteAdminCode())
  return data
}

export const updateIntegrationSchedule = async (id, schedule) => {
  const { data } = await clasolSuiteApi.patch(`/integrations/${encodeURIComponent(id)}/schedule`, schedule, withSuiteAdminCode())
  return data
}

export const deleteIntegration = async (id) => {
  await clasolSuiteApi.delete(`/integrations/${encodeURIComponent(id)}`, withSuiteAdminCode())
}

export const createIntegrationExecution = async (id, execution = {}) => {
  const { data } = await clasolSuiteApi.post(`/integrations/${encodeURIComponent(id)}/executions`, execution, withSuiteAdminCode())
  return data
}

export const cancelIntegrationExecution = async (id, executionId) => {
  const { data } = await clasolSuiteApi.post(
    `/integrations/${encodeURIComponent(id)}/executions/${encodeURIComponent(executionId)}/cancel`,
    null,
    withSuiteAdminCode(),
  )
  return data
}

export const updateIntegrationExecution = async (id, execution) => {
  const { data } = await clasolSuiteApi.patch(`/integrations/executions/${encodeURIComponent(id)}`, execution, withSuiteAdminCode())
  return data
}

export const upsertIntegrationCheckpoint = async (id, checkpoint) => {
  const { data } = await clasolSuiteApi.post(`/integrations/${encodeURIComponent(id)}/checkpoints`, checkpoint, withSuiteAdminCode())
  return data
}

export const acknowledgeIntegrationAlert = async (id) => {
  const { data } = await clasolSuiteApi.post(`/integrations/alerts/${encodeURIComponent(id)}/acknowledge`, null, withSuiteAdminCode())
  return data
}

export const createIntegrationOutbox = async (outbox) => {
  const { data } = await clasolSuiteApi.post('/integrations/outbox', outbox, withSuiteAdminCode())
  return data
}

export const syncBusinessCentralPedidosExpediciones = async (payload) => {
  const { data } = await clasolSuiteApi.post('/integrations/business-central/pedidos-expediciones', payload, withSuiteAdminCode())
  return data
}
